import axios from "axios";
import { API } from "../Common";

let api_endpoint = API;

export default {
    setEndpoint: function (ep) {
        api_endpoint = ep;
    },
    logIn: function (auth) {
        let data = new FormData();
        data.append("email", auth.email);
        data.append("password", auth.password);

        return new Promise((resolve, reject) => {
            axios
                .post(api_endpoint + "admin_auth/sign_in/", data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    },
    logOut: function () {
        localStorage.removeItem("access-token");
        localStorage.removeItem("client");
        localStorage.removeItem("user");

        if (localStorage.getItem("restore_login")) return;

        // we should keep login data, if restore_login true
        localStorage.removeItem("uid");
        localStorage.removeItem("p");
        localStorage.removeItem("partner_id");
    },
    isLogin: function () {
        let access_token = localStorage.getItem("access-token");
        let client = localStorage.getItem("client");
        let uid = localStorage.getItem("uid");
        let user = localStorage.getItem("user");
        return access_token && client && uid && user;
    },
    getAuthData: function () {
        return {
            email: localStorage.getItem("uid"),
            password: localStorage.getItem("p")
        };
    }
};



// WEBPACK FOOTER //
// ./src/services/api/Auth.js